export default {
  Dollar: 'D',
  Hour: 'H'
}
